import defaultState from "./state";

const solicitudEditarEliminacionReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "OPEN_SOLICITUD_EDITAR_ELIMINACION": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion);
      if (action.modalAction) {
        detallePrestacion.codigoPrestacionPrestador = action.detalleSolicitudSol.COD_PRESTADOR;
        detallePrestacion.tipoPrestacion = action.detalleSolicitudSol.TIPO_PRESTACION;
        detallePrestacion.pabellonPrestacion = action.detalleSolicitudSol.GUARISMO;
        detallePrestacion.glosaPrestacionPrestador = action.detalleSolicitudSol.GLOSA_CODPRESTADOR;
        detallePrestacion.glosaGrupoPrestador = action.detalleSolicitudSol.GLOSA_GRUPOPRESTADOR;
        detallePrestacion.inicioVigenciaArancel = action.detalleSolicitudSol.FECHA_FIN_VIG;
        detallePrestacion.codigoFonasa = action.detalleSolicitudSol.CODIGO_FONASA;
        detallePrestacion.itemImed = action.detalleSolicitudSol.ITEM_IMED;
        detallePrestacion.tipoProfesional = action.detalleSolicitudSol.PROF_CCOD;
        detallePrestacion.tipoUnidad = action.detalleSolicitudSol.UNIDAD;
        detallePrestacion.montoArancelPrestacion = action.detalleSolicitudSol.VALOR;
        detallePrestacion.tipoAtencion = action.detalleSolicitudSol.TIPO_ATENCION;
        detallePrestacion.glosaTipoArancel = action.detalleSolicitudSol.ARANCEL;
        detallePrestacion.glosaCentroAtencion = action.detalleSolicitudSol.CENTRO_AT;
        detallePrestacion.rowGuid = action.detalleSolicitudSol.GUID;
      } else {
        detallePrestacion.codigoPrestacionPrestador = null;
        detallePrestacion.tipoPrestacion = null;
        detallePrestacion.pabellonPrestacion = null;
        detallePrestacion.glosaPrestacionPrestador = null;
        detallePrestacion.glosaGrupoPrestador = null;
        detallePrestacion.inicioVigenciaArancel = null;
        detallePrestacion.codigoFonasa = null;
        detallePrestacion.itemImed = null;
        detallePrestacion.tipoProfesional = null;
        detallePrestacion.tipoUnidad = null;
        detallePrestacion.montoArancelPrestacion = null;
        detallePrestacion.tipoAtencion = null;
        detallePrestacion.glosaTipoArancel = null;
        detallePrestacion.glosaCentroAtencion = null;
        detallePrestacion.rowGuid = null;
      }
      return Object.assign({}, state, {
        modalSolicitudEditarEliminacion: action.modalAction,
        detallePrestacion,
      });
    }

    case "SOLEDIT_ELIMINACION/CAMBIAR_INICIO_VIGENCIA_ARANCEL": {
      const detallePrestacion = Object.assign({}, state.detallePrestacion, {
        inicioVigenciaArancel: action.inicioVigenciaArancel,
        inicioVigenciaArancelError: action.error,
      });
      return Object.assign({}, state, {
        detallePrestacion,
      });
    }

    default:
      return state;
  }
};

export default solicitudEditarEliminacionReducer;



// WEBPACK FOOTER //
// ./src/components/ActualizarArancel/SolicitudEditarEliminacion/reducer.js